import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";

export type CommonHeaderProps = Pick<
  CardTxContentProps,
  "task" | "type" | "isFeed" | "handleShare" | "handleRefetchActivities"
>;

export const getCommonHeaderProps = ({
  task,
  type,
  isFeed,
  handleShare,
  handleRefetchActivities
}: CommonHeaderProps) => ({
  task,
  type,
  isFeed,
  onShare: handleShare,
  handleCloseActivitySuccess: handleRefetchActivities
});
